import { create } from 'zustand';

interface BankLinkingAeropayDialogState {
    isOpen: boolean;
    actions: {
        open: () => void;
        close: () => void;
    };
}

export const useBankLinkingAeropayDialogStore = create<BankLinkingAeropayDialogState>()((set) => ({
    isOpen: false,
    actions: {
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
    },
}));
